/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Removes_Events_NoteInputs */



/**
* | output |
* | --- |
* | "(removes events)" |
*
* @param {Qc_Removes_Events_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_removes_events_note = /** @type {((inputs?: Qc_Removes_Events_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Removes_Events_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("(supprime des événements)")
	if (locale === "de") return /** @type {LocalizedString} */ ("(entfernt Events)")
	if (locale === "it") return /** @type {LocalizedString} */ ("(rimuove eventi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("(удаляет события)")
	if (locale === "es") return /** @type {LocalizedString} */ ("(elimina eventos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("（会删除事件）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("（イベントを削除します）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("(इवेंट हटाता है)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("(remove eventos)")
	return /** @type {LocalizedString} */ ("(removes events)")
});